import Vue from "vue"
import {
    ApplicationInsights
} from '@microsoft/applicationinsights-web'

var __export = null;
var connectionString = null;
try
{
    connectionString = window.$env.namespaces.global.aiConnString;
}
catch(ex)
{
    console.warn("Application Insights monitoring has not been configured.  The connection string was not found.");
    console.warn(ex);
}

if(connectionString)
{
    __export = new ApplicationInsights({
        config: {
            connectionString: connectionString,
            enableAutoRouteTracking: true,
            disableExceptionTracking: false,
        }
    });
    Vue.prototype.appInsights = __export;
}

export default __export || null;
